import ShapeCard, { ShapeCardProps } from 'components/ShapeCard';
import React from 'react';

export type AdvertisementCardProps = ShapeCardProps;

const AdvertisementCard = ({
  tagText,
  tagVariant,
  headingText,
  backgroundColor = 'viridian.base',
  cta,
  mobileImage,
  desktopImage,
  ...rest
}: AdvertisementCardProps) => (
  <ShapeCard
    tagText={tagText}
    tagVariant={tagVariant}
    headingText={headingText}
    backgroundColor={backgroundColor}
    cta={{ ...cta, size: ['md', 'sm', 'sm'] }}
    addImageShape={true}
    maxWidth={['100%']}
    minHeight={['auto', '400px']}
    mobileImage={mobileImage}
    mobileImageProps={{ height: '200px' }}
    desktopImage={desktopImage}
    cardVariant="horizontal"
    {...rest}
  />
);

export default AdvertisementCard;
